import { render, staticRenderFns } from "./AllTransView.vue?vue&type=template&id=71f8f0a1"
import script from "./AllTransView.vue?vue&type=script&lang=js"
export * from "./AllTransView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports